import { render, staticRenderFns } from "./TermEditRelationship.vue?vue&type=template&id=4ebcbbe6&scoped=true"
import script from "./TermEditRelationship.vue?vue&type=script&lang=js"
export * from "./TermEditRelationship.vue?vue&type=script&lang=js"
import style0 from "./TermEditRelationship.vue?vue&type=style&index=0&id=4ebcbbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebcbbe6",
  null
  
)

export default component.exports